"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsServiceFactory = void 0;
var feature_flags_service_factory_1 = require("./feature-flags-service-factory");
Object.defineProperty(exports, "FeatureFlagsServiceFactory", { enumerable: true, get: function () { return feature_flags_service_factory_1.FeatureFlagsServiceFactory; } });
